import { render, staticRenderFns } from "./FormPasswordRecovery.vue?vue&type=template&id=32453e0e&"
import script from "./FormPasswordRecovery.vue?vue&type=script&lang=js&"
export * from "./FormPasswordRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports